import React, { useEffect, useState } from "react";
import { Button, Table, Col, ButtonToolbar } from "react-bootstrap";
import { connect } from "react-redux";

import StockChart from "./stock-chart";
import { fetchStock, addWatchlist, removeWatchlist } from "../actions/index";
import utils from "../utils";
import SearchBar from "./search-bar";
import { useCreateConfigModal, useDataSelectors } from "../hooks";
import Modal from "./common/modal";
import { CreateConfigForm } from "./alerts";
import { useQuery } from "react-query";

const RecentDataTable = ({ data }) => (
  <Col md={4} mdOffset={4}>
    <h3>Recent Data</h3>
    <Table condensed responsive hover>
      <thead>
        <tr>
          <th>Fee</th>
          <th>Available</th>
          <th align="right">Updated</th>
        </tr>
      </thead>
      <tbody>
        {[...data].reverse().map((el) => (
          <tr key={el.datetime}>
            <td>{el.fee != null ? utils.toPercentage(el.fee) : "N/A"}</td>
            <td>{utils.toCommas(el.available)}</td>
            <td>{el.datetime.replace("T", " ")}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  </Col>
);

const HistoricalReport = ({
  fetchStock,
  match,
  stock: { symbol, name, csv, daily, real_time, country },
  watchlist,
  removeWatchlist,
  addWatchlist,
}) => {
  const {
    showFee,
    setFee,
    showAvailable,
    setAvailable,
    showClose,
    setClose,
    showVolume,
    setVolume,
  } = useDataSelectors();
  const {
    addAlert,
    createAlertSymbol,
    clearCreateAlertSymbol,
  } = useCreateConfigModal();
  useEffect(() => {
    fetchStock(match.params.ticker);
  }, [match.params.ticker]);
  const [queryEnabled, setQueryEnabled] = useState(false);

  useEffect(() => {
    if (showVolume || showClose) {
      setQueryEnabled(true);
    }
  }, [showVolume, showClose]);
  const { data } = useQuery(`/api/ticker/${match.params.ticker}/prices`, {
    enabled: queryEnabled,
    staleTime: Infinity,
  });
  const priceData = data?.results || [];

  const contains = watchlist && watchlist.some((el) => symbol === el.symbol);
  const action = contains ? removeWatchlist : addWatchlist;

  return (
    <div>
      <SearchBar />
      {name != null ? (
        <>
          <h2>
            {name} - {symbol}
          </h2>
          <ButtonToolbar>
            <Button
              onClick={() => action(symbol)}
              bsStyle={contains ? "danger" : "success"}
            >
              {contains ? "Remove from Watchlist" : "Add to Watchlist"}
            </Button>
            <Button onClick={() => addAlert(symbol)} bsStyle="success">
              Add Alert
            </Button>
            {csv && <Button href={csv}>CSV Export</Button>}
          </ButtonToolbar>

          {daily != null ? (
            <StockChart
              country={country}
              historicalData={daily}
              priceData={priceData}
              showFee={showFee}
              setFee={setFee}
              showAvailable={showAvailable}
              setAvailable={setAvailable}
              showClose={showClose}
              setClose={setClose}
              showVolume={showVolume}
              setVolume={setVolume}
            />
          ) : (
            <div>No Data found</div>
          )}
          {real_time && <RecentDataTable data={real_time} />}
          {createAlertSymbol != null ? (
            <Modal
              show
              title={`${createAlertSymbol} New Alert`}
              onHide={clearCreateAlertSymbol}
            >
              <CreateConfigForm
                symbol={createAlertSymbol}
                onComplete={clearCreateAlertSymbol}
              />
            </Modal>
          ) : null}
        </>
      ) : (
        <div>Loading...</div>
      )}
    </div>
  );
};

const mapStateToProps = ({ stock, watchlist, auth }) => ({
  stock,
  watchlist,
  subscribed: auth.subscribed,
});

export default connect(mapStateToProps, {
  fetchStock,
  addWatchlist,
  removeWatchlist,
})(HistoricalReport);
